/*总书记讲历史*/
import {MOSTSOUGHT,ZHONGSHUJI,urlpostfix,jsonpostfix} from '@/config/global.js'
import {getJSON} from '@/config/config.js'


/*export function getjlsdata(data){
  return getJSON(`/allWzJSON/${TELLASTORY}/${TELLASTORY}.json`);
}*/


/*总书记*/
export function getzsjdata(data){
  return getJSON(`${jsonpostfix}allWzJSON/${ZHONGSHUJI}/${ZHONGSHUJI}.json`);
}
/*重大活动*/
export function getjlsdata(data){
  return getJSON(`${jsonpostfix}allWzJSON/${MOSTSOUGHT}/${MOSTSOUGHT}.json`);
}







// WEBPACK FOOTER //
// ./src/api/generalsecretary.js